import React from "react";
import DoctorLayout from "../../components/Layout/DoctorLayout-new";
import LayoutWithbg from "../../components/LayoutWithbg";
import OtShell from "./components/OtShell";

/**
 * Wraps OT pages the way every other module does it:
 *
 *     DoctorLayout  — the hospital's top navbar
 *       LayoutWithbg — the page background
 *         OtShell    — the module's own dark sidebar
 *
 * Emergency composes the same three layers explicitly in App.js; OT keeps them
 * together here so its route block stays one line per screen.
 */
export default function OTAppShell({ setSearchText, children }) {
  return (
    <DoctorLayout setSearchText={setSearchText}>
      <LayoutWithbg>
        <OtShell>{children}</OtShell>
      </LayoutWithbg>
    </DoctorLayout>
  );
}
